import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { Button, Typography } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { NextSeo } from 'next-seo'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import Snackbar from '@mui/material/Snackbar'
import Header from '@/src/components/HeaderV2'
import Footer from '@/src/components/Footer/Footer2'
import LogIn from '@/src/components/SignIn/LogIn'
import Profile from '@/src/components/SignIn/Profile'
import SetPassword from '@/src/components/SignIn/SetPassword'
import SignInResetPwdEmail from '@/src/components/SignIn/SignInResetPwdEmail'
import SignUp from '@/src/components/SignIn/SignUp'
import VerifyEmail from '@/src/components/SignIn/VerifyEmail'
import { useBackend } from '@/src/providers/BackendProvider'
const MySnackbar = styled(Snackbar)`
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed !important;
  left: 0 !important;
  bottom: 50vh !important;
  transform: translate(calc(50vw - 50%), 50%) !important;
  backdrop-filter: blur(2px);
  border-radius: 8px;
  width: 220px;
  div {
    background-color: rgba(0, 0, 0, 0);
    justify-content: center;
  }
`

const TabPanel = (props) => {
  const { children, value, index, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.PropTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

// Forgot Password

const ForgotPassword = ({ setResetPwdEmail, setCurrentView }) => {
  return (
    <>
      <SignInResetPwdEmail setResetPwdEmail={setResetPwdEmail} setCurrentView={setCurrentView} />
    </>
  )
}

const EmailSent = ({ setCurrentView, resetPwdEmail }) => {
  const router = useRouter()
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const { sendResetPasswordEmail } = useBackend()
  const handleBackToSignIn = () => {
    router.push('/SignIn')
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenSnackBar(false)
  }

  const handleResend = async () => {
    await sendResetPasswordEmail(resetPwdEmail)
    setOpenSnackBar(true)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
      <Typography variant="h4">Reset password link sent</Typography>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography variant="body2">We've sent you an email to reset your password.</Typography>
        <Typography variant="body2">
          To create your new password, click the link in the email and enter a new one.
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Button
          variant="primary"
          loadable
          size="large"
          handleClick={handleResend}
          width="184px"
          id="sign-in-page-resend-button"
        >
          RESEND
        </Button>
      </div>
      <MySnackbar
        open={openSnackBar}
        autoHideDuration={800}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={handleClose}
        message="Email sent!"
      />
    </div>
  )
}

const CheckoutContent = ({ checkoutText, resetSucceed, verified, setVerify, signedin, ...props }) => {
  // view toggling
  const [currentView, setCurrentView] = useState('LogIn')
  const [logInEmail, setLogInEmail] = useState('')
  const [signUpEmail, setSignUpEmail] = useState('')
  const [resetPwdEmail, setResetPwdEmail] = useState('')
  const router = useRouter()
  const params = new URLSearchParams(router.asPath)
  // const code = typeof window === 'undefined' ? null : window.location.href.split('Code=')[1]

  useEffect(() => {
    setLogInEmail(sessionStorage.getItem('logInEmail'))
    setSignUpEmail(sessionStorage.getItem('signUpEmail'))
    if (router.asPath === '/SignIn/CreateAccount') {
      setCurrentView('SignUp')
    } else {
      setCurrentView('LogIn')
    }
    if (params.toString().indexOf('verifyEmail') !== -1) {
      setCurrentView('SetPassword')
    }
    if (params.toString().indexOf('resetPassword') !== -1) {
      setCurrentView('ResetPassword')
    }
    if (params.toString().indexOf('forgetPassword') !== -1) {
      setCurrentView('ForgotPassword')
    }
    if (params.toString().indexOf('InitialVerifyEmail') !== -1) {
      setCurrentView('InitialVerifyEmail')
    }
    if (params.toString().indexOf('UnverifiedVerifyEmail') !== -1) {
      setCurrentView('UnverifiedVerifyEmail')
    }
  }, [router])

  return (
    <>
      <NextSeo
        title={
          currentView === 'ResetPassword'
            ? 'Reset Password  | Orka - Hear what matters'
            : 'Account  | Orka - Hear what matters'
        }
        description={
          currentView === 'ResetPassword'
            ? 'To reset your password, Orka will send a verification email to your address. Please click the link in the email and proceed to change your password.'
            : 'Welcome back! Log in to your Orka account and check our updates about your Orka hearing aids! If there are any issues with your account, please contact us.'
        }
      />
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            backgroundColor: '#FFFFFF',
            padding: '40px',
            height: 'fit-content',
            marginTop: '15vh',
            marginBottom: '5vh',
            width: '600px',
            borderRadius: '16px',
            [theme.breakpoints.down('sm')]: {
              padding: '36px 16px',
              width: '92%',
              maxWidth: '92%',
              marginBottom: '5vh'
            }
          }}
        >
          {currentView === 'LogIn' && (
            <LogIn
              setCurrentView={setCurrentView}
              checkoutText={checkoutText || ''}
              logInEmail={logInEmail}
              setLogInEmail={setLogInEmail}
            />
          )}
          {currentView === 'SignUp' && (
            <SignUp setCurrentView={setCurrentView} signUpEmail={signUpEmail} setSignUpEmail={setSignUpEmail} />
          )}
          {currentView === 'SetPassword' && <SetPassword setCurrentView={setCurrentView} type="set" />}
          {currentView === 'ForgotPassword' && (
            <ForgotPassword setCurrentView={setCurrentView} setResetPwdEmail={setResetPwdEmail} />
          )}
          {currentView === 'EmailSent' && <EmailSent setCurrentView={setCurrentView} resetPwdEmail={resetPwdEmail} />}
          {currentView === 'ResetPassword' && <SetPassword setCurrentView={setCurrentView} type="reset" />}
          {currentView === 'InitialVerifyEmail' && (
            <VerifyEmail
              type="initial"
              signUpEmail={signUpEmail}
              setCurrentView={setCurrentView}
              setSignUpEmail={setSignUpEmail}
            />
          )}
          {currentView === 'UnverifiedVerifyEmail' && (
            <VerifyEmail
              type="unverified"
              logInEmail={logInEmail}
              setCurrentView={setCurrentView}
              setSignUpEmail={setSignUpEmail}
            />
          )}
          {currentView === 'Profile' && <Profile signUpEmail={signUpEmail} />}
        </Box>
      </div>
    </>
  )
}

const SignIn = ({ toggleDrawer, checkoutText, resetSucceed, verified, ...props }) => {
  const [verify, setVerify] = useState(verified)
  const [LogIn, setLogIn] = useState()
  const { signedin } = useBackend()
  useEffect(() => {
    setLogIn(signedin)
  }, [signedin])

  return (
    <div
      style={{
        background: theme.palette.secondary[100],
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        height: '100vh'
      }}
    >
      <NextSeo
        title="Account | Orka Hearing Aids"
        description="Welcome back! Log in to your Orka account and check our updates about your Orka hearing aids! If there are any issues with your account, please contact us."
      />
      <Header isWhiteBg />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          overflowX: 'hidden',
          height: '100%',
          backgroundColor: theme.palette.secondary[100]
        }}
      >
        <CheckoutContent
          checkoutText={checkoutText || ''}
          resetSucceed={resetSucceed}
          verified={verify}
          signedin={LogIn}
          setVerify={setVerify}
        />
      </div>
      <Footer miniMode={true} />
    </div>
  )
}

export default SignIn
